module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Добавить документ":"Add document","Удалить документ":"Remove document","Документ #":"Document #","Тип документа":"Document type"}}')
  delete Component.options._Ctor
}
